import { render, staticRenderFns } from "./EditEmployee.vue?vue&type=template&id=68afc60c&"
import script from "./EditEmployee.vue?vue&type=script&lang=js&"
export * from "./EditEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports